import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import DurationLabel from '../../../../BaseComponents/Labels/Duration'
import { ImageIcon, ImageLabel } from '../../../../BaseComponents/Image/Components'
import { BasicTeaserProps } from '../../../TeaserInterface'
import { BigListTeaserImage } from '../HelperClass'

const BigListTeaserVideoImage = ({
    mainImageUrl,
    mainImageAlt,
    labels,
    videoDuration,
}: BasicTeaserProps): ReactElement => {
    return (
        <Grid noExpand position="relative">
            <BigListTeaserImage mainImageUrl={mainImageUrl} mainImageAlt={mainImageAlt} />
            {labels && (
                <Grid display={['none', 'none', 'flex']} position="absolute">
                    <ImageLabel margin={5} labels={labels} />
                </Grid>
            )}

            <ImageIcon type="video" size={['XS', 'XS', 'S', 'S']} />
            {videoDuration && (
                <Grid
                    zIndex={5}
                    position="absolute"
                    width="100%"
                    height="100%"
                    alignRight
                    alignBottom
                    display={['none', 'none', 'flex']}
                >
                    <Grid noExpand margin={5}>
                        <DurationLabel duration={videoDuration} />
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}

export default BigListTeaserVideoImage
